/*
 * Copyright (C) 2011-2019 ShenZhen iBOXCHAIN Information Technology Co.,Ltd.
 *
 * All right reserved.
 *
 * This software is the confidential and proprietary
 * information of iBOXCHAIN Company of China.
 * ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only
 * in accordance with the terms of the contract agreement
 * you entered into with iBOXCHAIN inc.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    global
  }
})

const storeContext = require.context('@/store/modules', true, /\/index\.js$/)

storeContext.keys().forEach((modules) => {
  store.registerModule(modules.replace(/(^\.\/)|(\/index\.js$)/g, ''), storeContext(modules).default)
})
Vue.prototype.$store = store

export default store



// WEBPACK FOOTER //
// ./src/store/index.js